// extracted by mini-css-extract-plugin
module.exports = {"root":"Choice_root__1EUgG","dragIcon":"Choice_dragIcon__HUjK_","left":"Choice_left__3bxzr","input":"Choice_input__Sp5Vj"};